// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1O8Qh","col":"CardReaderDesc_col__3oezZ","label":"CardReaderDesc_label__fPI1w"};